export default __webpack_public_path__ + "static/media/lady-with-dog.959547cf.jpg";